import { MenuItem } from '@mui/material';
import { IconType } from 'react-icons';
import { primaryColourMain } from 'app/agriculture/material';

interface ContextMenuItemProps {
    title: string;
    Icon?: IconType;
    SecondIcon?: IconType;
    onClick?: () => void;
    tooltip?: string;
    id?: string;
}

export const ContextMenuItem = ({
    id,
    title,
    Icon,
    SecondIcon,
    onClick,
    tooltip,
}: ContextMenuItemProps) => {
    return (
        <MenuItem
            id={id}
            className="ContextMenu__item"
            disableGutters
            disableRipple
            onClick={onClick}
            title={tooltip}
        >
            {Icon && <Icon color={primaryColourMain} size={20} />}
            <h5>{title}</h5>
            {SecondIcon && <SecondIcon color={primaryColourMain} size={16} />}
        </MenuItem>
    );
};
